// Copyright 2026, Imprivata, Inc.  All rights reserved.

/**
 * Returns true when `value` parses as an absolute URL via the WHATWG URL
 * constructor. Mirrors the legacy `saas-admin-ui` helper.
 */
export const isValidUrl = (value: string): boolean => {
  try {
    const parsed = new URL(value);
    return Boolean(parsed);
  } catch {
    return false;
  }
};
